"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _reactApollo = require("react-apollo");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _configuratorApollo = _interopRequireDefault(require("./configurator-apollo"));
var _configurator = require("./configurator.props/configurator.propTypes");
var Configurator = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Configurator, _React$Component);
  function Configurator() {
    return _React$Component.apply(this, arguments) || this;
  }
  Configurator.resourceType = function resourceType() {
    return 'VehicleConfigurator_1_0_0';
  };
  var _proto = Configurator.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      market = _this$props.config.market,
      data = _this$props.data;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'car_configuration_view',
        comp_product: {
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: null,
          version: null,
          color: null,
          upholstery: null,
          accesories: null,
          fuel_type: null,
          price: null,
          currency: null,
          step: "1/" + data.steps.filter(function (s) {
            return s.label;
          }).length
        }
      });
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme,
      path = _this$props2.path,
      config = _this$props2.config;
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.ApolloConsumer, null, function (client) {
      return /*#__PURE__*/_react["default"].createElement(_configuratorApollo["default"], {
        theme: theme,
        data: data,
        client: client,
        market: config.market,
        language: config.language,
        path: path
      });
    });
  };
  return Configurator;
}(_react["default"].Component);
Configurator.displayName = 'Configurator';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(Configurator);
exports["default"] = _default;